import { render, staticRenderFns } from "./typeface.vue?vue&type=template&id=a05c9f0e&scoped=true&lang=pug&"
import script from "./typeface.vue?vue&type=script&lang=js&"
export * from "./typeface.vue?vue&type=script&lang=js&"
import style0 from "./typeface.vue?vue&type=style&index=0&id=a05c9f0e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a05c9f0e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('a05c9f0e', component.options)
    } else {
      api.reload('a05c9f0e', component.options)
    }
    module.hot.accept("./typeface.vue?vue&type=template&id=a05c9f0e&scoped=true&lang=pug&", function () {
      api.rerender('a05c9f0e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form_element/typography/typeface.vue"
export default component.exports